import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { UserBreathWorkoutService } from 'src/app/services/user-breath-workout.service';

@Component({
  selector: 'app-breathe-all-entries',
  templateUrl: './breathe-all-entries.component.html',
  styleUrls: ['./breathe-all-entries.component.scss']
})
export class BreatheAllEntriesComponent implements OnInit {
  isLoading = false;
  userData: any;
  breatheMinsWeek: any;
  breatheLast7Days: any;
  allEntries: any;
  breatheWeekData: any;
  allWeeksData: any = [];
  userWeek: any;
  exercises:any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();
  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    public userBreatheService: UserBreathWorkoutService,
  ) {}
  ngOnInit(): void {
    forkJoin({
      allEntries: this.userBreatheService.fetchAll()
    }).subscribe((responseData) => {
      this.allEntries = responseData.allEntries;

      this.breatheWeekData = this.userBreatheService.generateWeekData(
        this.currentWeek,
        this.allEntries
      );

      this.allWeeksData.push(this.breatheWeekData);
      let endOfWeek = this.currentWeek[6];
      let weeksRun = 0;
      this.userService.userData.subscribe((userData) => {
        this.isLoading = false;
        if (userData) {
          this.userData = userData;
          while (
            moment(endOfWeek).subtract(1, 'week') >
              moment(this.userData.date_registered) &&
            weeksRun < 100
          ) {
            weeksRun++;
            let prevWeek = this.dateHelperService.getWeekFor(
              moment(endOfWeek).subtract(1, 'week')
            );
            let prevWeekData = this.userBreatheService.generateWeekData(
              prevWeek,
              this.allEntries
            );
            this.allWeeksData.push(prevWeekData);
            endOfWeek = prevWeek[6];
          }
          this.userWeek = this.allWeeksData.length;
        }
      });
    });
  }
}
